import Layout from "@/components/Layout";
import EstimateWizard from "@/components/estimate/EstimateWizard";

const FreeEstimate = () => {
  return (
    <Layout>
      <section className="py-12 md:py-20 bg-muted min-h-[calc(100vh-200px)]">
        <div className="container mx-auto px-4">
          <EstimateWizard />
        </div>
      </section>
    </Layout>
  );
};

export default FreeEstimate;
